import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "preview"]
  static values = { rows: Object, teams: Object, truncated: Boolean, emptyLabel: String, notImportedLabel: String }

  connect() {
    this.selectTargets.forEach((select) => this.render(select))
  }

  update(event) {
    this.render(event.target)
  }

  render(select) {
    const preview = this.previewTargets.find((target) => target.dataset.key === select.dataset.key)

    if (select.value === "") {
      preview.replaceChildren(this.badge(this.notImportedLabelValue, "badge-warning"))
      return
    }

    const values = this.rowsValue[select.value] || []

    if (values.every((value) => this.blank(value))) {
      preview.replaceChildren(this.badge(this.emptyLabelValue, "badge-ghost"))
      return
    }

    preview.replaceChildren(...values.map((value) => this.line(value, select.dataset.resolveTeams === "true")))

    if (this.truncatedValue) {
      preview.append(this.ellipsis())
    }
  }

  ellipsis() {
    const element = document.createElement("div")

    element.textContent = "…"
    return element
  }

  blank(value) {
    return value === null || value === undefined || value === ""
  }

  badge(label, modifier) {
    const element = document.createElement("span")

    element.textContent = label
    element.classList.add("badge", "rounded-full", modifier)
    return element
  }

  line(value, resolveTeams) {
    const element = document.createElement("div")

    if (this.blank(value)) {
      element.textContent = this.emptyLabelValue
      element.classList.add("italic", "opacity-60")
      return element
    }

    element.textContent = resolveTeams && this.teamsValue[value] ? `${value} · ${this.teamsValue[value]}` : value
    return element
  }
}
